const Pagination = ({ visiblePages, current_page, handlePageClick }) => {
  if (!visiblePages || visiblePages.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "6px",
        padding: "16px 10px",
      }}
    >
      {visiblePages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={index}
            onClick={() => handlePageClick(page)}
            style={{
              minWidth: "32px",
              height: "32px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "0.86rem",
              fontWeight: 700,
              fontFamily: "inherit",
              color: page === current_page ? "#FFF" : "#7A8490",
              backgroundColor: page === current_page ? "#0E141B" : "transparent",
              border: "none",
              cursor: "pointer",
              transition: "background-color .12s, color .12s",
            }}
            onMouseEnter={(e) => {
              if (page !== current_page)
                e.currentTarget.style.backgroundColor = "#F4F8F7";
            }}
            onMouseLeave={(e) => {
              if (page !== current_page)
                e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            {page}
          </button>
        ) : (
          <span
            key={index}
            style={{
              minWidth: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#B9C1C9",
              fontWeight: 700,
              cursor: "default",
            }}
          >
            {page}
          </span>
        )
      )}
    </div>
  );
};

export default Pagination;
